import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { TipoOcupacionConfiguracion } from '../../_models/tipo-ocupacion-configuracion';
import { TipoOcupacionConfiguracionService } from '../../_services/tipo-ocupacion-configuracion.service';
import {Observable} from 'rxjs';

@Component( {
  selector: 'app-tipo-ocupacion-configuracion-listado',
  templateUrl: 'tipo-ocupacion-configuracion-listado.component.html'
} )

export class TipoOcupacionConfiguracionListadoComponent implements OnInit {

  carInformacionInicial = true;
  lisTipoOcupacion: TipoOcupacionConfiguracion[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private tipOcupacionConfiguracionService: TipoOcupacionConfiguracionService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/tipo-ocupacion-configuracion' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigoTipoOcupacion', header: this.navServicio.buscarMensaje( 'LBL_CODIGO' ), sort: false },
      { field: 'nombreTipoOcupacion', header: this.navServicio.buscarMensaje( 'TIPOOCUPACION.LBL_TIPOOCUPACION' ), sort: false },
      { field: 'indicadorAnalizamos', header: this.navServicio.buscarMensaje( 'TIPOOCUPACION.LBL_ANALIZAMOS' ), sort: false },
      { field: 'indicadorFlujoDigital', header: this.navServicio.buscarMensaje( 'TIPOOCUPACION.LBL_FLUJODIGITAL' ), sort: false },
      { field: 'orden', header: this.navServicio.buscarMensaje( 'LBL_ORDEN' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.busqueda = this.navServicio.getSearch( 'tipo-ocupacion-configuracion.component' );
    this.carInformacionInicial = true;
    this.consulta();

  }
  async consulta() {
    this.tipOcupacionConfiguracionService.listadoSecuencia().subscribe( listado => {
      this.lisTipoOcupacion = listado;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );

  }

  crear() {
    this.router.navigate( [ 'apl/tipo-ocupacion-configuracion/agregar' ] );
  }

  ver( regDetalle: TipoOcupacionConfiguracion ) {
    this.router.navigate( [ 'apl/tipo-ocupacion-configuracion/detalle/' + regDetalle.idTipoOcupacionConfiguracion ] );
  }

  editar( regActualizar: TipoOcupacionConfiguracion ) {
    this.router.navigate( [ 'apl/tipo-ocupacion-configuracion/actualizar/' + regActualizar.idTipoOcupacionConfiguracion ] );
  }
  capacidadPago( regActualizar: TipoOcupacionConfiguracion ) {
    this.router.navigate( [ 'apl/tipo-ocupacion-configuracion/CapacidadPago/' + regActualizar.idTipoOcupacionConfiguracion ] );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'tipo-ocupacion-configuracion.component', this.busqueda );
  }
  async cambiarOrden( item: any, subir: boolean ) {

    let miIndice = this.lisTipoOcupacion.indexOf( item );
    if ( subir ) {
      this.carInformacionInicial = true;
      const nueva = this.lisTipoOcupacion[ miIndice ];
      nueva.secuencia = nueva.secuencia - 1;
      const actual = this.lisTipoOcupacion[ miIndice - 1 ];
      actual.secuencia = actual.secuencia + 1;
      const lisCreditoDigitale = [];
      lisCreditoDigitale.push(nueva);
      lisCreditoDigitale.push(actual);
      const creditoDigital = await this.tipOcupacionConfiguracionService.bulk(lisCreditoDigitale).toPromise();
      await this.consulta();
      this.carInformacionInicial = false;

    } else {
      this.carInformacionInicial = true;
      const nueva = this.lisTipoOcupacion[ miIndice ];
      nueva.secuencia = nueva.secuencia + 1;
      const actual = this.lisTipoOcupacion[ miIndice + 1 ];
      actual.secuencia = actual.secuencia - 1;
      const lisCreditoDigitale = [];
      lisCreditoDigitale.push(nueva);
      lisCreditoDigitale.push(actual);
      const creditoDigital = await this.tipOcupacionConfiguracionService.bulk(lisCreditoDigitale).toPromise();
      await this.consulta();
      this.carInformacionInicial = false;
    }

  }
}
